// Mock data for Phocea Rent - Location d'écrans LED

export const packs = [
  {
    id: 1,
    name: "Pack S - DJ Booth 2m²",
    size: "S",
    surface: "2m²",
    dimensions: "2 m × 1 m",
    price: 749,
    description: "Environ 2 m² – Format idéal pour cabine DJ ou façade scène",
    image: "https://customer-assets.emergentagent.com/job_101ab4cd-4d37-431a-b507-ce3ea7ef67e4/artifacts/gu1bc6jg_Pack%20%C3%A9cran%20LED%202m2.png",
    usages: ["DJs", "Clubs", "Bars festifs", "Événements privés"],
    includes: ["Dalles LED", "Vidéo processeur inclus", "Bumpers", "Câblage & alimentation", "Flight cases"],
    highlight: "Impact visuel immédiat avec un investissement minimal",
    bonus: "Vidéo processeur inclus",
    popular: false
  },
  {
    id: 2,
    name: "Pack M - Compact 4m²",
    size: "M",
    surface: "4m²",
    dimensions: "2,50 m × 1,50 m",
    price: 1199,
    description: "Format polyvalent pour fond de scène et branding événementiel",
    image: "https://customer-assets.emergentagent.com/job_101ab4cd-4d37-431a-b507-ce3ea7ef67e4/artifacts/vm87efqp_Pack%20%C3%A9cran%20LED%204m2.png",
    usages: ["Fond de scène", "Branding événementiel", "DJ sets premium"],
    includes: ["Dalles LED", "Vidéo processeur inclus", "Bumpers (structure non fournie)", "Câblage & alimentation", "Flight cases"],
    highlight: "Kit complet prêt à l'emploi",
    bonus: "Vidéo processeur inclus",
    popular: false
  },
  {
    id: 3,
    name: "Pack L - Standard 7m²",
    size: "L",
    surface: "7m²",
    dimensions: "3,50 m × 2 m",
    price: 1999,
    description: "Le format le plus demandé – Excellent équilibre entre surface, impact et budget",
    image: "https://customer-assets.emergentagent.com/job_101ab4cd-4d37-431a-b507-ce3ea7ef67e4/artifacts/nenk0vgh_Pack%20%C3%A9cran%20LED%207m2.png",
    usages: ["Fan zones", "Événements sportifs", "Concerts", "Scènes extérieures"],
    includes: ["Dalles LED", "Vidéo processeur inclus", "Bumpers (structure non fournie)", "Câblage & alimentation", "Flight cases"],
    highlight: "Format le plus demandé",
    bonus: "Vidéo processeur inclus",
    popular: true
  },
  {
    id: 4,
    name: "Pack XL - Premium 15m²",
    size: "XL",
    surface: "15m²",
    dimensions: "5 m × 3 m",
    price: 3499,
    description: "Solution haut de gamme, forte visibilité, forte valeur perçue",
    image: "https://customer-assets.emergentagent.com/job_101ab4cd-4d37-431a-b507-ce3ea7ef67e4/artifacts/uncbzflz_Pack%20%C3%A9cran%20LED%2015m2.png",
    usages: ["Événements majeurs", "Diffusion sportive", "Grandes scènes", "Corporate premium"],
    includes: ["Dalles LED", "Vidéo processeur inclus", "Bumpers (structure non fournie)", "Câblage & alimentation", "Flight cases"],
    highlight: "Solution haut de gamme pour événements majeurs",
    bonus: "Vidéo processeur inclus",
    popular: false
  }
];

// ============== PROTECT + (optional coverage) ==============
export const PROTECT_PLUS_FRANCHISE = { damage: 375, theft: 750 };

// Keyed by pack surface (spaces removed). Monthly fee + reduced caution.
export const PROTECT_PLUS = {
  "2m²": { fee: 15, reducedCaution: 199 },
  "4m²": { fee: 25, reducedCaution: 349 },
  "7m²": { fee: 39, reducedCaution: 599 },
  "15m²": { fee: 59, reducedCaution: 1199 },
};

export const getProtectPlus = (pack) => {
  if (!pack) return null;
  const surf = String(pack.surface || pack.pack_surface || '').replace(/\s/g, '');
  return PROTECT_PLUS[surf] || null;
};

export const processSteps = [
  {
    id: 1,
    title: "Choisissez votre pack",
    description: "Sélectionnez le format adapté à votre événement parmi nos 4 packs prédéfinis.",
    icon: "Package"
  },
  {
    id: 2,
    title: "Renseignez vos infos",
    description: "Complétez vos coordonnées et téléchargez votre attestation RC professionnelle.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Payez en ligne",
    description: "Réglez la première mensualité + la caution de manière sécurisée.",
    icon: "CreditCard"
  },
  {
    id: 4,
    title: "Recevez votre matériel",
    description: "Livraison partout en France. Matériel prêt à l'emploi, plug & play.",
    icon: "Truck"
  },
  {
    id: 5,
    title: "Utilisez sans limite",
    description: "Exploitez vos écrans autant que vous voulez pendant toute la durée de location.",
    icon: "Zap"
  },
  {
    id: 6,
    title: "Restituez quand vous voulez",
    description: "Dès que votre besoin est terminé, rendez simplement le matériel. Frais de retour à votre charge. Caution restituée.",
    icon: "RotateCcw"
  }
];

export const advantages = [
  {
    title: "Sans engagement",
    description: "Minimum 1 mois, restitution libre ensuite. Pas de contrat 36-48 mois.",
    icon: "Unlock"
  },
  {
    title: "Clé en main",
    description: "Tout est inclus : dalles, structure, câbles, flight cases, vidéo processeur.",
    icon: "Package"
  },
  {
    title: "Plug & Play",
    description: "Matériel prêt à l'emploi. Aucune compétence technique requise.",
    icon: "Play"
  },
  {
    title: "Livraison France",
    description: "Nous livrons partout en France métropolitaine.",
    icon: "MapPin"
  },
  {
    title: "Utilisation illimitée",
    description: "Pendant votre période de location, utilisez vos écrans autant que vous voulez.",
    icon: "Infinity"
  },
  {
    title: "Prix transparent",
    description: "Un tarif mensuel fixe. Pas de surprise, pas de frais cachés.",
    icon: "Euro"
  }
];

export const faqs = [
  {
    question: "Quelle est la durée minimum de location ?",
    answer: "La durée minimum est de 1 mois. Vous pouvez ensuite restituer le matériel quand vous le souhaitez, sans préavis ni pénalité."
  },
  {
    question: "Qu'est-ce qui est inclus dans les packs ?",
    answer: "Les dalles LEDs correspondant à la surface du pack choisi, bumpers pour stabiliser l'écran, câbles d'alimentation, vidéo processeurs et flight cases de transport. Votre pack écran LED arrive sur palette et bien emballé."
  },
  {
    question: "Comment fonctionne la caution ?",
    answer: "Une caution égale au montant de la location mensuelle est demandée au début. Elle vous est intégralement restituée après contrôle du matériel à la restitution."
  },
  {
    question: "Livrez-vous partout en France ?",
    answer: "Oui, nous livrons partout en France métropolitaine. Les frais de livraison sont calculés selon votre localisation."
  },
  {
    question: "Comment se passe le retour de la commande ?",
    answer: "Une fois votre location terminée, vous organisez le retour du matériel. Les frais de retour sont à votre charge. Une fois le matériel réceptionné et contrôlé, votre caution vous est intégralement restituée."
  },
  {
    question: "Faut-il une assurance ?",
    answer: "Oui, vous devez disposer d'une assurance Responsabilité Civile professionnelle couvrant les biens loués et leur exploitation. Le justificatif est à fournir lors de la réservation."
  },
  {
    question: "Les écrans sont-ils adaptés à l'extérieur ?",
    answer: "Les écrans sont certifiés IP65. C'est une norme qui garantit l'étanchéité. Vous pouvez donc utiliser l'écran LED en extérieur, même par temps de pluie. Attention, ne pas immerger complètement l'écran ou en partie."
  },
  {
    question: "Et si un ou des produits sont abîmés ?",
    answer: "Nos produits sont résistants. Ils sont destinés à l'événementiel donc ne soyez pas trop craintif. Les accidents peuvent arriver c'est vrai, dans ce cas là, nous appliquerons une retenue sur la caution de 19€ par LED. Notre équipe évalue les dommages en atelier et vous contactera dans le cas où il y a une retenue sur caution."
  }
];

export const contact = {
  email: "contact@phocearent.fr",
  phone: "04 86 68 33 55",
  address: "Marignane (13), France"
};
